export default {
  default: () => import("/home/app/pd-awards-frontend/layouts/default.vue").then(m => m.default || m)
}